import Service from '../service'
import HrPreviderApvPaymentTypeMdl from '@/models/HumanResource/HrPreviredApvPaymentType'

export default class extends Service {
    static model = HrPreviderApvPaymentTypeMdl
}
